import { render, staticRenderFns } from "./ChatNotification.vue?vue&type=template&id=39944b13&scoped=true"
import script from "./ChatNotification.vue?vue&type=script&lang=js"
export * from "./ChatNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39944b13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39944b13')) {
      api.createRecord('39944b13', component.options)
    } else {
      api.reload('39944b13', component.options)
    }
    module.hot.accept("./ChatNotification.vue?vue&type=template&id=39944b13&scoped=true", function () {
      api.rerender('39944b13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatNotification.vue"
export default component.exports